module.exports = "/images/ico-blik-pp.svg?d6e8cb6a21bed216b36a15733f1e79f2";